import { supabase } from "@/integrations/supabase/client";

export const checkScrapingLimit = async (userId: string) => {
  const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();

  const { count, error } = await supabase
    .from('eventos')
    .select('*', { count: 'exact', head: true })
    .eq('user_id', userId)
    .in('tipo', ['click_whatsapp', 'click_site', 'click_instagram', 'click_email', 'view_perfil'])
    .gt('created_at', twentyFourHoursAgo);

  if (error) {
    console.error('Error checking scraping limit:', error);
    return false;
  }

  return (count || 0) >= 40;
};
